var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "query-sort-area" },
    [
      _c(
        "div",
        {
          staticClass: "basic-block",
          class: [_vm.extraExpanded ? "show-more" : ""]
        },
        [
          _c(
            "div",
            { staticClass: "query-items" },
            [
              _vm._l(_vm.basicQueryFields, function(queryField) {
                return [
                  !queryField.hidden && queryField.type == "Text"
                    ? _c("swb-query-text-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          placeholder: queryField.placeholder,
                          iniValue: queryField.value
                        },
                        on: {
                          Enter: function($event) {
                            _vm.handleEnterKey(queryField.code, $event)
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Date"
                    ? _c("swb-query-date-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          time: queryField.time,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        on: {
                          valueformat: function($event) {
                            _vm.syncValueFormat(queryField.code, $event)
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Date2"
                    ? _c("swb-query-date2-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          time: queryField.time,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        on: {
                          valueformat: function($event) {
                            _vm.syncValueFormat(queryField.code, $event)
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Time2"
                    ? _c("swb-query-time2-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Month"
                    ? _c("swb-query-month-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        on: {
                          change: function($event) {
                            _vm.callEventHandler(
                              queryField.code,
                              "change",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Month2"
                    ? _c("swb-query-month2-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Select"
                    ? _c("swb-query-select-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          dataList: queryField.dataList,
                          iniValue: queryField.value,
                          dataLabel: queryField.dataLabel,
                          dataValue: queryField.dataValue,
                          filterable:
                            queryField.filterable == null
                              ? false
                              : queryField.filterable,
                          firstOnClear:
                            queryField.firstOnClear == null
                              ? false
                              : queryField.firstOnClear,
                          multiple:
                            queryField.multiple == null
                              ? false
                              : queryField.multiple,
                          multipleLimit:
                            queryField.multipleLimit == null
                              ? 0
                              : queryField.multipleLimit,
                          collapseTags:
                            queryField.collapseTags == null
                              ? true
                              : queryField.collapseTags,
                          firstIsMutex:
                            queryField.firstIsMutex == null
                              ? false
                              : queryField.firstIsMutex
                        },
                        on: {
                          change: function($event) {
                            _vm.callEventHandler(
                              queryField.code,
                              "change",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Casc"
                    ? _c("swb-query-casc-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          dataList: queryField.dataList,
                          filterable:
                            queryField.filterable == null
                              ? false
                              : queryField.filterable,
                          multiple:
                            queryField.multiple == null
                              ? false
                              : queryField.multiple,
                          collapseTags:
                            queryField.collapseTags == null
                              ? true
                              : queryField.collapseTags
                        },
                        on: {
                          change: function($event) {
                            _vm.callEventHandler(
                              queryField.code,
                              "change",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Checkbox"
                    ? _c("swb-query-checkbox-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        on: {
                          change: function($event) {
                            _vm.callEventHandler(
                              queryField.code,
                              "change",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "RadioGroup"
                    ? _c("swb-query-radiogroup-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          dataList: queryField.dataList,
                          iniValue: queryField.value,
                          dataLabel: queryField.dataLabel,
                          dataValue: queryField.dataValue
                        },
                        on: {
                          change: function($event) {
                            _vm.callEventHandler(
                              queryField.code,
                              "change",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Num"
                    ? _c("swb-query-num-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Num2"
                    ? _c("swb-query-num2-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !queryField.hidden && queryField.type == "Popup"
                    ? _c("swb-query-popup-field", {
                        key: queryField.code,
                        ref: _vm.makeQueryFieldVueCtrlName(queryField.code),
                        refInFor: true,
                        attrs: {
                          disabled: queryField.disabled,
                          valueType: queryField.valueType,
                          label: queryField.label,
                          iniValue: queryField.value,
                          iniText: queryField.text
                        },
                        on: {
                          change: function($event) {
                            _vm.callEventHandlerForPopup(
                              queryField.code,
                              "change",
                              $event
                            )
                          },
                          popup: function($event) {
                            _vm.triggerPopupHandler(queryField.code, $event)
                          }
                        },
                        model: {
                          value: _vm.filterItems[queryField.code],
                          callback: function($$v) {
                            _vm.$set(_vm.filterItems, queryField.code, $$v)
                          },
                          expression: "filterItems[queryField.code]"
                        }
                      })
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              _vm.advQueryMode &&
              _vm.extraExpanded &&
              _vm.extraQueryFields.length > 0
                ? [
                    _vm._l(_vm.extraQueryFields, function(queryField) {
                      return [
                        !queryField.hidden && queryField.type == "Text"
                          ? _c("swb-query-text-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                placeholder: queryField.placeholder,
                                iniValue: queryField.value
                              },
                              on: {
                                Enter: function($event) {
                                  _vm.handleEnterKey(queryField.code, $event)
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Date"
                          ? _c("swb-query-date-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                time: queryField.time,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              on: {
                                valueformat: function($event) {
                                  _vm.syncValueFormat(queryField.code, $event)
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Date2"
                          ? _c("swb-query-date2-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                time: queryField.time,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              on: {
                                valueformat: function($event) {
                                  _vm.syncValueFormat(queryField.code, $event)
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Time2"
                          ? _c("swb-query-time2-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Month"
                          ? _c("swb-query-month-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              on: {
                                change: function($event) {
                                  _vm.callEventHandler(
                                    queryField.code,
                                    "change",
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Month2"
                          ? _c("swb-query-month2-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Select"
                          ? _c("swb-query-select-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                dataList: queryField.dataList,
                                iniValue: queryField.value,
                                dataLabel: queryField.dataLabel,
                                dataValue: queryField.dataValue,
                                filterable:
                                  queryField.filterable == null
                                    ? false
                                    : queryField.filterable,
                                firstOnClear:
                                  queryField.firstOnClear == null
                                    ? false
                                    : queryField.firstOnClear,
                                multiple:
                                  queryField.multiple == null
                                    ? false
                                    : queryField.multiple,
                                multipleLimit:
                                  queryField.multipleLimit == null
                                    ? 0
                                    : queryField.multipleLimit,
                                collapseTags:
                                  queryField.collapseTags == null
                                    ? true
                                    : queryField.collapseTags,
                                firstIsMutex:
                                  queryField.firstIsMutex == null
                                    ? false
                                    : queryField.firstIsMutex
                              },
                              on: {
                                change: function($event) {
                                  _vm.callEventHandler(
                                    queryField.code,
                                    "change",
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Casc"
                          ? _c("swb-query-casc-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                dataList: queryField.dataList,
                                filterable:
                                  queryField.filterable == null
                                    ? false
                                    : queryField.filterable,
                                multiple:
                                  queryField.multiple == null
                                    ? false
                                    : queryField.multiple,
                                collapseTags:
                                  queryField.collapseTags == null
                                    ? true
                                    : queryField.collapseTags
                              },
                              on: {
                                change: function($event) {
                                  _vm.callEventHandler(
                                    queryField.code,
                                    "change",
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Checkbox"
                          ? _c("swb-query-checkbox-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              on: {
                                change: function($event) {
                                  _vm.callEventHandler(
                                    queryField.code,
                                    "change",
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "RadioGroup"
                          ? _c("swb-query-radiogroup-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                dataList: queryField.dataList,
                                iniValue: queryField.value,
                                dataLabel: queryField.dataLabel,
                                dataValue: queryField.dataValue
                              },
                              on: {
                                change: function($event) {
                                  _vm.callEventHandler(
                                    queryField.code,
                                    "change",
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Num"
                          ? _c("swb-query-num-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Num2"
                          ? _c("swb-query-num2-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !queryField.hidden && queryField.type == "Popup"
                          ? _c("swb-query-popup-field", {
                              key: queryField.code,
                              ref: _vm.makeQueryFieldVueCtrlName(
                                queryField.code
                              ),
                              refInFor: true,
                              attrs: {
                                disabled: queryField.disabled,
                                valueType: queryField.valueType,
                                label: queryField.label,
                                iniValue: queryField.value,
                                iniText: queryField.text
                              },
                              on: {
                                change: function($event) {
                                  _vm.callEventHandler(
                                    queryField.code,
                                    "change",
                                    $event
                                  )
                                },
                                popup: function($event) {
                                  _vm.triggerPopupHandler(
                                    queryField.code,
                                    $event
                                  )
                                }
                              },
                              model: {
                                value: _vm.filterItems[queryField.code],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filterItems,
                                    queryField.code,
                                    $$v
                                  )
                                },
                                expression: "filterItems[queryField.code]"
                              }
                            })
                          : _vm._e()
                      ]
                    })
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.extraExpanded,
                  expression: "extraExpanded"
                }
              ],
              staticClass: "sort-btn-group mt10"
            },
            [
              _vm._l(_vm.enabledSortFields, function(sortField) {
                return [
                  _c("swb-query-sort-field", {
                    key: sortField.code,
                    attrs: { label: sortField.label, order: sortField.order },
                    on: {
                      sortFieldChanged: function($event) {
                        _vm.handleSortFieldChange(sortField.code, $event)
                      },
                      sortFieldDisabled: function($event) {
                        _vm.disableSortField(sortField.code)
                      }
                    },
                    model: {
                      value: _vm.sortItems[sortField.code],
                      callback: function($$v) {
                        _vm.$set(_vm.sortItems, sortField.code, $$v)
                      },
                      expression: "sortItems[sortField.code]"
                    }
                  })
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "query-btns",
              class: [_vm.extraExpanded ? "show-more" : ""]
            },
            [
              _c("div", { staticClass: "operation-btn-group" }, [
                _c(
                  "div",
                  {
                    staticClass: "query-btn",
                    on: {
                      click: function($event) {
                        _vm.callQueryHanlder()
                      }
                    }
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "senior-btn",
                    attrs: { title: "高级" },
                    on: { click: _vm.switchExtraBlock }
                  },
                  [
                    _c("i", {
                      staticClass: "icon iconfont",
                      class: [
                        _vm.extraExpanded
                          ? "icon-double-arrow-up"
                          : "icon-double-arrow-down"
                      ]
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.extraExpanded && _vm.custConfEnabled && _vm.mountedFlag
                ? _c(
                    "div",
                    { staticClass: "other-more" },
                    [
                      _c(
                        "el-link",
                        {
                          staticStyle: { "font-size": "12px" },
                          attrs: { icon: "el-icon-set-up" },
                          on: {
                            click: function($event) {
                              _vm.showQueryConfUI($event)
                            }
                          }
                        },
                        [_vm._v("查询设置")]
                      ),
                      _vm._v(" "),
                      _vm.haveSortFields
                        ? _c("el-divider", { attrs: { direction: "vertical" } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.haveSortFields
                        ? _c(
                            "el-link",
                            {
                              staticClass: "mr10",
                              staticStyle: { "font-size": "12px" },
                              attrs: { icon: "el-icon-set-up" },
                              on: {
                                click: function($event) {
                                  _vm.showSortConfUI($event)
                                }
                              }
                            },
                            [_vm._v("排序设置")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hisQueryBtnVisible(),
                              expression: "hisQueryBtnVisible()"
                            }
                          ]
                        },
                        [
                          _c("el-divider", {
                            attrs: { direction: "vertical" }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-link",
                            {
                              staticClass: "mr10",
                              staticStyle: { "font-size": "12px" },
                              attrs: { icon: "el-icon-orange" },
                              on: { click: _vm.showHisRecordsViewDlg }
                            },
                            [_vm._v("历史查询")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.custConfEnabled
        ? _c(
            "swb-dt-popover",
            {
              ref: "queryConfPopover",
              attrs: { placement: "right-start" },
              on: {
                show: function($event) {
                  _vm.syncQueryConfUIVisible(true)
                },
                hide: function($event) {
                  _vm.syncQueryConfUIVisible(false)
                }
              },
              model: {
                value: _vm.queryConfUIVisible,
                callback: function($$v) {
                  _vm.queryConfUIVisible = $$v
                },
                expression: "queryConfUIVisible"
              }
            },
            [
              _c("swb-query-field-conf", {
                ref: "queryConfRef",
                attrs: {
                  forHisQry: _vm.forHisQry,
                  showExtBtns: _vm.showConfExtBtns,
                  custSavable: _vm.isCustStorable(),
                  onConfirm: _vm.onQueryConfConfirm,
                  onClose: _vm.onQueryConfCancel,
                  onSaveCustConf: _vm.onSaveQueryConfInfo,
                  basicMaxSpaces: _vm.basicMaxSpaces,
                  metaQueryFields: _vm.liveQueryFields,
                  custQueryFields: _vm.custQueryFields
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.custConfEnabled
        ? _c(
            "swb-dt-popover",
            {
              ref: "sortConfPopover",
              attrs: { placement: "right-start" },
              on: {
                show: function($event) {
                  _vm.syncSortConfUIVisible(true)
                },
                hide: function($event) {
                  _vm.syncSortConfUIVisible(false)
                }
              },
              model: {
                value: _vm.sortConfUIVisible,
                callback: function($$v) {
                  _vm.sortConfUIVisible = $$v
                },
                expression: "sortConfUIVisible"
              }
            },
            [
              _c("swb-sort-field-conf", {
                ref: "sortConfRef",
                attrs: {
                  forHisQry: _vm.forHisQry,
                  showExtBtns: _vm.showConfExtBtns,
                  custSavable: _vm.isCustStorable(),
                  onConfirm: _vm.onSortConfConfirm,
                  onClose: _vm.onSortConfCancel,
                  onSaveCustConf: _vm.onSaveSortConfInfo,
                  metaSortFields: _vm.liveSortFields,
                  custSortFields: _vm.custSortFields
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0638e54d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0638e54d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/query/QuerySortArea.vue
// module id = 2178
// module chunks = 0